module.exports = class ReviewFormCtrl
  constructor: ->
    'ngInject'

  submitReview: ->
    @onSubmit()
